import { ApiResponse } from '@/types';
import { CMSPageTitleType, ICmsContent } from '@/types/entities/cms.entities';

import http from '../http';

export const fetchCmsContentByType = async (pageTitle: CMSPageTitleType) =>
  http.get<ApiResponse<{ cmsPage: ICmsContent }>>(`/cms/by-type/${pageTitle}`);
